import script from "./TwoFactorVerification.vue?vue&type=script&setup=true&lang=js"
export * from "./TwoFactorVerification.vue?vue&type=script&setup=true&lang=js"

import "./TwoFactorVerification.vue?vue&type=style&index=0&id=2f4fb13c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2f4fb13c"]])

export default __exports__